const LinkUtil = (function () {
	var self = {
		create: function (url) {
			var anchor = document.createElement('a');
			anchor.href = url;

			return anchor;
		}
	};

	return self;

})();

export default LinkUtil;
